import mori from 'mori';

/**
 * Tests whether the given row is a datatype row, by testing against possible
 * datatypes.
 * @param {array} row - An array of cell values for the row
 * @param {array} types - The expanded list of datatype tuples
 * @return {bool} Whether this is a datatype row or not
 */
export default function(row, types) {
  if (!types) {
    return false;
  }
  return mori.every((x) => {
    const tempX = (x || '').split('--');
    const rowValue = tempX.length === 2 &&
      ['narrow', 'wide'].indexOf(tempX[1].toLowerCase()) > -1 ?
        tempX[0] : x;
    return (rowValue === null ||
            mori.some((type) =>
              mori.first(type) === rowValue.toLowerCase(), types) ||
                /^Date-/.test(rowValue));
  }, mori.rest(row));
}



// WEBPACK FOOTER //
// ../~/eslint-loader!./js/services/transducerUtils/isDatatypeRow.js